export default __webpack_public_path__ + "static/media/asia_exam.aefe0c7e.png";